﻿function currentDate() {
    const today = new Date();
    const timeZoneOffset = today.getTimezoneOffset();
    const timeZoneMsk = timeZoneOffset < 0 ? timeZoneOffset + 180 : timeZoneOffset;
    return new Date(today.setMinutes(today.getMinutes() + timeZoneMsk));
}

function getFullDate() {
    const date = currentDate();
    return date.toLocaleString('ru', {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    });
}

function isValid(str: any) {
    return str.slice(0, str.lastIndexOf(':')) !== '00:00';
}

function parseDate(date: string): Date | null {
    if (!date) return null;
    const regex = /(\d{2}).(\d{2}).(\d{4})/;
    const parsed = regex.exec(date);

    if (parsed) {
        return new Date(parseInt(parsed[3]), parseInt(parsed[2]) - 1, parseInt(parsed[1]));
    }

    const tryDate = new Date(date);
    return !isNaN(tryDate.getTime()) ? tryDate : null;
}

function parseDateTime(dateTime: string): Date | null {
    if (!dateTime) return null;
    const regex = /(\d{2}).(\d{2}).(\d{4}) (\d{2}):(\d{2})/;
    const parsed = regex.exec(dateTime);

    if (parsed) {
        return new Date(parseInt(parsed[3]), parseInt(parsed[2]) - 1, parseInt(parsed[1]), parseInt(parsed[4]), parseInt(parsed[5]));
    }

    const tryDate = new Date(dateTime);
    return !isNaN(tryDate.getTime()) ? tryDate : null;
}

function getClientTimeZone(): number {
    return -(new Date().getTimezoneOffset() / 60);
}

function updateTimeZone() {
    const timeZone = getClientTimeZone();
    if (window.mvcTimeZone !== timeZone) {
        window.ajaxGet(`/TimeZone/Update?timezone=${timeZone}`);
        window.mvcTimeZone = timeZone;
    }
}

/**
 * Приводит время в часовом клиента ко времени в часовом поясе сервера
 * */
function toServerTimeZone(time: Date | string, serverTimeZone: number): Date {
    let resultTime: Date;
    if (time && typeof time === 'string' && time.includes('Date(')) {
        resultTime = new Date(parseInt(time.replace('/Date(', '').replace(')', '')));
    }
    else {
        resultTime = new Date(time);
    }

    const clientTimeZone = getClientTimeZone();
    const offset = serverTimeZone - clientTimeZone;
    resultTime.setMinutes(resultTime.getMinutes() + offset * 60);
    return resultTime;
}

/**
 * Приводит время в часовом сервера ко времени в часовом поясе клиента
 * */
function toClientTimeZone(time: Date | string, serverTimeZone: number): Date {
    let resultTime: Date;
    if (time && typeof time === 'string' && time.includes('Date(')) {
        resultTime = new Date(parseInt(time.replace('/Date(', '').replace(')', '')));
    }
    else {
        resultTime = new Date(time);
    }

    const clientTimeZone = getClientTimeZone();
    const offset = serverTimeZone - clientTimeZone;
    resultTime.setMinutes(resultTime.getMinutes() - offset * 60);
    return resultTime;
}

/**
 * разбираем строку времени ЧЧ:ММ на часы и минуты
 * */
function parseTime(stringTime: string): string[] {
    const hoursEndPosition = stringTime.indexOf(':');
    const hours = stringTime.slice(0, hoursEndPosition);
    const minutes = stringTime.slice(hoursEndPosition + 1, stringTime.length);
    return [hours, minutes];
}

/**
 * Функция форматирования времени в формате ЧЧ:ММ:CC
 * */
function getTimeFromSeconds(secs: number) {
    const hours = Math.floor(secs / (60 * 60));

    const divisorForMinutes = secs % (60 * 60);
    const minutes = Math.floor(divisorForMinutes / 60);

    const divisorForSeconds = divisorForMinutes % 60;
    const seconds = Math.ceil(divisorForSeconds);

    return `${window.getString(hours)}:${window.getString(minutes)}:${window.getString(seconds)}`;
}

/**
 * Функция форматирования времени в формате ЧЧ:ММ и ЧЧЧ:ММ
 * */
function formatTime(cost: any, returnIfNull: string = ''): string {
    if (cost === null || Number.isNaN(cost)) return returnIfNull;

    let sHours = window.leftPad((cost / 60 >> 0), 2);
    let sMinutes = window.leftPad((cost % 60), 2);
    if (sMinutes.includes('-')) {
        sMinutes = sMinutes.substring(1, sMinutes.length);
        if (!sHours.includes('-')) sHours = `-${sHours}`;
    }
    return `${sHours}:${sMinutes}`;
}

function convertTotalMinutes(hours: number, minutes: number) {
    return hours * 60 + minutes;
}

function applyEmployeeTimeZoneForTimePicker(date: string | Date, serverTimeZone: number) {
    date = new Date(date);
    return new Date(date.getTime() + (60 * 60 * 1000 * (-serverTimeZone)));
}

function applyServerTimeZoneForTimePicker(date: string | Date, serverTimeZone: number) {
    date = new Date(date);
    const clientTimeZone = -(new Date().getTimezoneOffset() / 60);
    return new Date(date.getTime() + (60 * 60 * 1000 * (serverTimeZone - clientTimeZone + 5)));
}

function reverseServerTimeZoneForTimePicker(date: string | Date, serverTimeZone: number) {
    date = new Date(date);
    const clientTimeZone = -(new Date().getTimezoneOffset() / 60);
    return new Date(date.getTime() - (60 * 60 * 1000 * (serverTimeZone - clientTimeZone)));
}

function dateTimeToString(date: Date) {
    return `${window.formatNumber(date.getDate(), 2)}.${window.formatNumber(date.getMonth() + 1, 2)}.${date.getFullYear()} ${window.formatNumber(date.getHours(), 2)}:${window.formatNumber(date.getMinutes(), 2)}`;
}

function formatDateForDataPicker(stringDate: string) {
    const date = parseDate(stringDate);
    return `${date?.getFullYear()}/${date?.getMonth()}/${date?.getDate()}`;
}

function areDatesEqual(first: Date, second: Date) {
    return first.getFullYear() === second.getFullYear() &&
        first.getMonth() === second.getMonth() &&
        first.getDate() === second.getDate();
}

window.updateTimeZone = updateTimeZone;
window.parseDateTime = parseDateTime;
window.isValid = isValid;
window.parseDate = parseDate;
window.applyServerTimeZoneForTimePicker = applyServerTimeZoneForTimePicker;
window.areDatesEqual = areDatesEqual;
window.applyEmployeeTimeZoneForTimePicker = applyEmployeeTimeZoneForTimePicker;
window.convertTotalMinutes = convertTotalMinutes;
window.currentDate = currentDate;
window.formatTime = formatTime;
window.dateTimeToString = dateTimeToString;
window.formatDateForDataPicker = formatDateForDataPicker;
window.getFullDate = getFullDate;
window.getTimeFromSeconds = getTimeFromSeconds;
window.parseTime = parseTime;
window.getClientTimeZone = getClientTimeZone;
window.reverseServerTimeZoneForTimePicker = reverseServerTimeZoneForTimePicker;
window.toClientTimeZone = toClientTimeZone;
window.toServerTimeZone = toServerTimeZone;